import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PageSlotModule, OutletRefModule } from '@spartacus/storefront';

import { StoreLocatorComponent } from '../../components/static/store-locator/store-locator.component';
import { AbstractPageComponent } from '../../templates/abstract-page/abstract-page.component';

@Component({
  selector: 'wc-store-locator-page',
  templateUrl: './store-locator-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PageSlotModule,
    OutletRefModule,
    StoreLocatorComponent
  ]
})
export class StoreLocatorPageComponent extends AbstractPageComponent {}
